import { BlogPost } from '@commerce/types/blog'
import { Breadcrumbs, SEO } from '@components/common'
import { ReactNode } from 'react'

interface Props {
  blogPost: BlogPost
  children: ReactNode
}

const BlogPostWrapper: React.FC<Props> = (props) => {
  const { blogPost, children } = props

  return (
    <>
      {blogPost.seo && (
        <SEO
          title={blogPost.seo?.title || blogPost.title}
          description={blogPost.seo?.description || blogPost.title}
          openGraph={{
            type: 'website',
            title: blogPost.seo?.title || blogPost.title,
            description: blogPost.seo?.description || blogPost.title,
            images: [
              {
                url: blogPost.image?.url,
                width: '800',
                height: '600',
                alt: blogPost.seo?.title || blogPost.title,
              },
            ],
          }}
        />
      )}
      <section className="wrapper pb-10">
        <Breadcrumbs
          options={[
            {
              label: blogPost.blog.title,
              link: `/blogs/${blogPost.blog.handle}`,
            },
          ]}
          current={blogPost.title}
        />
        <div className="mx-auto sm:px-6 md:px-8 xl:px-12 lg:max-w-5xl mt-12">
          <h1 className="text-mobileh3 lg:text-h2 text-text-dark text-center">
            {blogPost.title ?? blogPost.seo?.title}
          </h1>
          <h2 className="text-text-subdued font-normal text-center text-body1 lg:text-body1 mt-6 w-full lg:w-10/12 mx-auto">
            {blogPost.seo?.description}
          </h2>
          <div className="h-auto w-full relative mt-8">
            <img
              src={blogPost.image?.url}
              width="100%"
              height="100%"
              alt={blogPost.title ?? blogPost.image?.altText}
            />
          </div>
        </div>
      </section>
      {children}
    </>
  )
}

BlogPostWrapper.displayName = 'Blog Post Wrapper'

export default BlogPostWrapper
